import * as React from "react";

import * as classNames from "classnames";
import { Control, Errors } from "react-redux-form";
import {
    mapProps,
    showErrors,
    updateOn,
    validateOn
} from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";
import { requiredDate } from "../../../Common/validators";
import OldDateTimePicker from "./OldDateTimePicker";

export interface DateTimeControlProps {
    input: boolean;
    mandatory: boolean;
    model: string;
    readOnly?: boolean;

    viewMode?: string;
    validate?: any;
    touched?: any;
    valid?: any;
}

class OldDateTimeControl extends React.PureComponent<DateTimeControlProps, any> {
    render() {
        return (
            <div
                className={classNames(
                    "form-group",
                    {
                        "has-danger":
                            this.props.validate &&
                            !this.props.valid &&
                            this.props.touched &&
                            !this.props.readOnly
                    }
                )}
            >
                <Control.text
                    model={this.props.model}
                    placeholder=""
                    validators={{
                        required: this.props.mandatory ? requiredDate : () => true
                    }}
                    component={OldDateTimePicker}
                    updateOn={updateOn}
                    validateOn={validateOn}
                    mapProps={mapProps}
                    controlProps={{
                        label: "",
                        validate: true,
                        input: this.props.input,
                        viewMode: this.props.viewMode,
                        timeFormat: this.props.viewMode === "time" ? "hh:mm a" : false
                    }}
                    readOnly={this.props.readOnly}
                />
                <Errors
                    model={this.props.model}
                    messages={{
                        required: "Please select a date"
                    }}
                    className="invalid-feedback d-block"
                    show={showErrors}
                    component={ValidationMessage}
                />
            </div>
        );
    }
}

export default OldDateTimeControl;
